/* eslint-disable import/prefer-default-export */

import { makeEntityScaffold } from '@classpass/saga-tools';

export const promotionByAlias = makeEntityScaffold(
  'SAGA.API.PROMOTION_BY_ALIAS',
  (client, promoAlias, msaId, params) =>
    client.promotions.getPromotionByAlias(promoAlias, {
      ...params,
      ...(msaId ? { msa_id: msaId } : {}),
    }),
  { defaultKey: (client, promoAlias, msaId) => (msaId ? `${promoAlias}_${msaId}` : promoAlias) }
);

export const promotionByAliasAndCoordinates = makeEntityScaffold(
  'SAGA.API.PROMOTION_BY_ALIAS_V2',
  (client, promoAlias, coordinates, params) =>
    client.promotions.getPromotionByAliasV2(promoAlias, {
      ...params,
      ...(coordinates && { latitude: coordinates.lat, longitude: coordinates.lon }),
    }),
  { defaultKey: (client, promoAlias, { lat, lon }) => (lat && lon ? `${promoAlias}_${lat}_${lon}` : promoAlias) }
);

export const msaOfferById = makeEntityScaffold(
  'SAGA.API.MSA_OFFER_BY_ID',
  (client, msaOfferId, params) => client.promotions.getMsaOfferById(msaOfferId, params),
  { defaultKey: 1 }
);

export const defaultPromotion = makeEntityScaffold(
  'SAGA.API.DEFAULT_PROMOTION',
  (client, state, msaId, platform = 'web') =>
    client.promotions
      .getDefaultPromotionForState(state, {
        platform,
        ...(msaId ? { msa_id: msaId } : {}),
      })
      .then(
        data =>
          data && {
            ...data,
            ...data.content,
          }
      ),
  { defaultKey: [1, 2] }
);
